// Import model
import { DataviewUserResponse } from '../models/DataviewUserResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterUserRequest } from '../models/FilterUserRequest';
import { User } from '../models/User';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterUserRequestSerializer } from './FilterUserRequestSerializer';
import { UserSerializer } from './UserSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewUserResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewUserResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewUserResponse instance
   */
  static deserialize(json: string): DataviewUserResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewUserResponse instance
   */
  static fromObject(obj: any): DataviewUserResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewUserResponse');
    }


    const instance: DataviewUserResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        UserSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterUserRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewUserResponse instances
   */
  static deserializeArray(json: string): DataviewUserResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewUserResponse instance to a JSON string
   */
  static serialize(instance: DataviewUserResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewUserResponse instance to a plain object
   */
  static toObject(instance: DataviewUserResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        UserSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterUserRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewUserResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewUserResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
